import {
  WebhookInterface,
  WebhookParamsInterface,
  WebhookSubscriptionEventEnum,
  WebhookUpdateInterface,
} from '../types/webhook-settings-interface'
import { mapSubscriptions } from './map-subscriptions'

const requiredKeys: (keyof Omit<WebhookUpdateInterface, 'subscriptions'>)[] = [
  'name',
  'secret',
  'active',
]

export const getDiffBody = (
  params: WebhookParamsInterface,
  selectedEvents: Record<WebhookSubscriptionEventEnum, boolean>,
  prevValues: WebhookInterface,
) => {
  const changedKeys = requiredKeys.filter(
    key =>
      params[key as keyof WebhookParamsInterface] !== prevValues[key as keyof WebhookInterface],
  )

  const subscriptionsBody: WebhookUpdateInterface = {
    subscriptions: mapSubscriptions(selectedEvents),
  }

  const body = changedKeys.reduce((acc, next) => {
    // @ts-ignore
    subscriptionsBody[next] = params[next as keyof WebhookParamsInterface]
    return acc
  }, subscriptionsBody)

  return body
}
